import { Model } from "pinia-orm";
import {
  QuestionBatch,
  Choice,
  Competence,
  QuestionQuestionnaireDocument,
  QuestionnaireSessionQuestion,
} from "@/models";
import { appVerboseName } from "@/utils/const";

export default class Question extends Model {
  static entity = "questions";
  static primaryKey = "uuid";

  static fields() {
    return {
      uuid: this.uid(""),
      updateAt: this.string(""),
      createdAt: this.string(""),
      createdBy: this.string(""),
      modifiedBy: this.string(""),
      extraData: this.attr({}),
      relatedObjectUuid: this.string(""),
      title: this.string(""),
      servicesRelatedName: this.attr([appVerboseName.toLocaleLowerCase()]),
      questionType: this.string(""),
      isMandatory: this.boolean(false),
      isPublished: this.boolean(false),
      isArchived: this.boolean(false),
      text: this.attr(null),
      photo: this.attr(null),
      order: this.number(null),
      notation: this.number(null),
      correctChoicesNumber: this.number(null),
      isDisplayed: this.boolean(true),
      choices: this.hasMany(Choice, "question"),
      questionBatchsList: this.hasMany(QuestionBatch, "questionUuid"),
      competenceData: this.belongsTo(Competence, "relatedObjectUuid"),
      questionnaireSessionQuestionList: this.hasMany(QuestionnaireSessionQuestion, "questionUuid"),
      questionQuestionnaireDocumentsList: this.hasMany(
        QuestionQuestionnaireDocument,
        "questionUuid",
      ),
      questionnaireDocuments: this.attr([]),
    };
  }

  get extraDataDomainUuids() {
    return this.extraData.domain_uuids;
  }
}
